<div class="mdTitle-f">
  <img src="assets/image/shield-icon.png" class="title-img" alt="" />
  {{ "common.carProtectionPlan" | translate }}
</div>
<div class="content-wrapper">
  <div>
    <div class="label-desc">{{ "common.typeOfInsurance" | translate }} :</div>
    <div class="label-value">
      @switch (data.insuranceType) {
        @case ('COM') {
          {{
          "common.COM" | translate
          }}
        }
        @case ('TPFT') {
          {{
          "common.TPFT" | translate
          }}
        }
        @default {
          {{
          "common.TP" | translate
          }}
        }
      }
    </div>
  </div>
  <div>
    <div class="label-desc">{{ "common.effectivePeriod" | translate }} :</div>
    <div class="label-value">
      {{ data.effectiveDate | date : "dd MMM yyyy" }}
    </div>
  </div>
</div>
